import { baseApi } from 'segments/api/baseApi';

import { adapteGroupsList } from '../utils/adapter';
import { transformGroupeInfo } from '../utils/transformer';

import type {
  UpdateGroupeParams,
  GroupsList,
  CreateGroupeParams,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGroupsList: builder.query<GroupsList, void>({
      query: () => ({
        url: '/admin/groups/list',
        method: 'GET',
      }),
      transformResponse: adapteGroupsList,
      providesTags: ['GroupsList'],
      keepUnusedDataFor: 1,
    }),

    createGroupe: builder.mutation<unknown, CreateGroupeParams>({
      query: (formData: CreateGroupeParams) => ({
        url: '/admin/groups/create',
        method: 'POST',
        body: transformGroupeInfo(formData)
      }),
      invalidatesTags: ['GroupsList'],
    }),

    deleteGroupe: builder.mutation<unknown, number>({
      query: (id: number) => ({
        url: `/admin/groups/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['GroupsList'],
    }),

    updateGroupe: builder.mutation<unknown, UpdateGroupeParams>({
      query: ({ id, ...formData }: UpdateGroupeParams) => ({
        url: `/admin/groups/update/${id}`,
        method: 'PUT',
        body: transformGroupeInfo(formData),
      }),
      invalidatesTags: ['GroupsList'],
    }),
  }),
});

export const {
  useGetGroupsListQuery,
  useUpdateGroupeMutation,
  useDeleteGroupeMutation,
  useCreateGroupeMutation
} = api;
